import React, { useState, useRef, useEffect } from 'react';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import './UserInfo.css';

const UserInfo = ({ userInfo, onLogout, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const initial = userInfo?.displayName ? userInfo.displayName.charAt(0).toUpperCase() : 'U';

  return (
    <div
      ref={containerRef}
      className={`relative ${className}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center justify-center h-9 w-9 rounded-full focus:outline-none"
      >
        {userInfo?.avatar ? (
          <img
            className="h-9 w-9 rounded-full object-cover"
            src={userInfo.avatar}
            alt={userInfo.displayName}
          />
        ) : (
          <div className="h-9 w-9 rounded-full bg-avatarBg flex items-center justify-center">
            <span className="text-white font-bold" style={{ fontSize: '0.875rem' }}>
              {initial}
            </span>
          </div>
        )}
      </button>

      {isOpen && (
        <div className="user-profile__dropdown !min-w-[240px] !w-auto">
          <div className="px-4 py-3 border-b border-headerBorder">
            <p className="text-textSecondary font-medium uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.06em' }}>
              Profile Details
            </p>
            <p className="text-textPrimary font-semibold mt-1" style={{ fontSize: '0.875rem' }}>
              {userInfo?.displayName || 'User'}
            </p>
            <p className="text-textSecondary truncate" style={{ fontSize: '0.8rem' }}>
              {userInfo?.email || ''}
            </p>
          </div>
          <div className="py-1">
            <button
              onClick={onLogout}
              className="flex items-center w-full px-4 py-2 text-signOut hover:bg-panelHover transition-colors duration-150"
              style={{ fontSize: '0.875rem' }}
            >
              <ArrowRightOnRectangleIcon className="w-[18px] h-[18px] mr-3" />
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
